import { Grid, Link, List, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import Project from '../components/Project';

const YatzyParty = () => {
    const list = [
        `Built most of the UI Screens and Animations;`,
        `Implemented FTUE and Tutorials;`,
        `Metagame features like Collectables and IAP's;`,
    ];

    return (
        <Project>
            <Grid item xs={12}>
                <div className='aspect-ratio'>
                    <iframe
                        width='1904'
                        height='778'
                        src='https://www.youtube.com/embed/FbuE5SZvZ6E'
                        title='Yatzy Party! Trailer'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                    ></iframe>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h1' component='h1' gutterBottom>
                    Yatzy Party!
                </Typography>
                <Typography variant='overline' display='block'>
                    Async Multiplayer Yatzy with Friends
                </Typography>
                <br />
                <Typography gutterBottom>
                    My team was responsible for remaking and expanding the
                    original HTML5 version to a native version using Unity.
                </Typography>
                <Typography gutterBottom>
                    We were 6 people developing the game and half of our team
                    was Canadian, so we worked remotely with daily standup
                    meetings. The brazilian team also spent a whole month
                    working together with the Canadian Team in Montreal.
                </Typography>
                <br />
                <Typography>
                    <strong>Some of my tasks included:</strong>
                </Typography>
                <List>
                    {list.map((t, i) => (
                        <ListItemText key={`task-${i}`}>
                            &bull; {t}
                        </ListItemText>
                    ))}
                </List>
                <br />
                <Typography gutterBottom>
                    Developed at{' '}
                    <Link href='https://www.gazeus.com/en/'>Gazeus Games</Link>{' '}
                    and available on{' '}
                    <Link href='https://play.google.com/store/apps/details?id=com.jogatina.yatzy.party.dice&hl=en&gl=US'>
                        Google Play
                    </Link>{' '}
                    and{' '}
                    <Link href='https://apps.apple.com/br/app/yatzy-party-a-new-dice-game/id1318325507?l=en'>
                        Apple Store
                    </Link>
                    .
                </Typography>
            </Grid>
        </Project>
    );
};

export default YatzyParty;
